import "bootstrap/dist/css/bootstrap.css";
import SearchEngine from "./SearchEngine";
import "./App.css";

function App() {
  return (
    <div className="App bg-image">
      <section className="Top-section">
        <SearchEngine />
      </section>

      <footer class="Page-footer container-fluid p-0">
        {" "}
        Webpage made by Jin Mia kris -
        <div className="link-girhub">
          <a
            href={"https://github.com/jinmiakris/weather-react-challenge.git"}
            target="_blank"
            rel="noreferrer"
            alt="link to github"
          >
            View on Github{" "}
          </a>
        </div>
      </footer>
    </div>
  );
}

export default App;
